import React from 'react';

// Styles
import s from './styles.module.css';

// Components
import { Content as RadixContent, AccordionContentProps as RadixContentProps } from '@radix-ui/react-accordion';

// Re export components
export { RadixContent };

// Re export types
export type { RadixContentProps };

// Types
export interface ContentSharedProps {
  ContentComponent?: React.FC<ContentProps> | React.FC<any>;
  contentClass?: string;
}
export interface ContentSpecificProps extends ContentSharedProps {
  clsPrefix?: string;
}
export interface ContentProps extends ContentSpecificProps, RadixContentProps {}

// Component
export const Content = ({
  ContentComponent = RadixContent,
  children,
  clsPrefix = 'radix-accordion',
  contentClass = '',
  className = contentClass,
  ...props
}: ContentProps) => {
  return <ContentComponent className={`${s.content} ${clsPrefix}-content ${className}`} {...props}>
      {children}
    </ContentComponent>;
};